import * as React from "react";
import type { SVGProps } from "react";
const SvgStratrgyorderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="stratrgyorder_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M341.333 234.667a85.333 85.333 0 0 1 85.334-85.334h218.581a85.333 85.333 0 0 1 59.221 23.894l122.752 118.4a85.333 85.333 0 0 1 26.112 61.44V640A85.333 85.333 0 0 1 768 725.333H426.667A85.333 85.333 0 0 1 341.333 640V234.667zM426.667 64A170.667 170.667 0 0 0 256 234.667 170.667 170.667 0 0 0 85.333 405.333v384A170.667 170.667 0 0 0 256 960h302.507a166.827 166.827 0 0 0 165.93-149.333H768A170.667 170.667 0 0 0 938.667 640V353.067a170.667 170.667 0 0 0-52.224-122.88l-122.71-118.358A170.667 170.667 0 0 0 645.205 64H426.667zm211.456 746.667a81.536 81.536 0 0 1-79.616 64H256a85.333 85.333 0 0 1-85.333-85.334v-384A85.333 85.333 0 0 1 256 320v320a170.667 170.667 0 0 0 170.667 170.667h211.456zm-168.79-405.334a42.667 42.667 0 1 1 0-85.333H640a42.667 42.667 0 1 1 0 85.333H469.333zm-42.666 128A42.667 42.667 0 0 0 469.333 576h256a42.667 42.667 0 1 0 0-85.333h-256a42.667 42.667 0 0 0-42.666 42.666z"
    />
  </svg>
);
export default SvgStratrgyorderIcon;
